export const SET_LOCALE = "SET_LOCALE";
export const LOAD_FROM_CACHE = "LOAD_FROM_CACHE";
export const SET_DEALS = "SET_DEALS";
export const LAYOUT_TOGGLE_SUBHEADER = "LAYOUT_TOGGLE_SUBHEADER";
export const LAYOUT_TOGGLE_PRIMARY_CHAT = "LAYOUT_TOGGLE_PRIMARY_CHAT";
export const LAYOUT_TOGGLE_SECONDARY_CHAT = "LAYOUT_TOGGLE_SECONDARY_CHAT";
export const LAYOUT_HIDE_SECONDARY_CHAT = "LAYOUT_HIDE_SECONDARY_CHAT";
